<script setup lang="ts">
import { alert } from "@/services";
import { localize } from "@/utils";
import HomeFooter from "@/views/home/HomeFooter.vue";
import HomeHeader from "@/views/home/HomeHeader.vue";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref, Ref } from "vue";

const downloadLink: Ref<string> = ref("https://download.r2playground.com");

const openYouTube = () => {
  window.open('https://www.youtube.com/@r2gatetv', '_blank');
};
</script>

<template>
  <div id="wrap" class="r2playground">
    <home-header />

    <!-- container -->
    <!-- 페이지 시작 -->
    <main id="ct">
      <div class="player-intro illust-intro">
        <span>{{ localize("일하는 것이 가장 즐거운 놀이다") }}</span>
        <h1 class="heading">R2 Player</h1>
        <p
          class="fs-4"
          v-html="
            localize('임상을 쉽고 즐겁게 만드는 다양한 솔루션들을 만나보세요.')
          "
        />
        <div class="player-intro-illu">
          <div class="r2 d-none d-md-block"></div>
          <img src="@/assets/home/img/playground/r2.png" class="d-md-none" alt="" />
          <swiper
            :loop="true"
            :observer="true"
            :observe-parents="true"
            :modules="[Navigation, Pagination]"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            :pagination="{
              el: '.illust-intro .swiper-pagination',
              type: 'bullets',
            }"
          >
            <swiper-slide>
              <router-link :to="{ name: 'home-r2-solution', query: { section: 0 } }" class="illu-s1">
                <strong>
                  R2 Digital
                  <br />
                  Implant
                </strong>
                <!-- 다국어 누락 -->
                <div class="txt" v-html="localize('임플란트 플래닝과 가이드 디자인<br/>원데이 임플란트까지')" />
              </router-link>
            </swiper-slide>
            <swiper-slide>
              <router-link :to="{ name: 'home-r2-solution', query: { section: 1 } }" class="illu-s2">
                <strong>
                  R2studio Q<br/>
                  & QVD
                </strong>
                <!-- 다국어 누락 -->
                <div class="txt" v-html="localize('심미 보철, 무치악 환자의<br />치료 계획을 Ai로 간단하게')" />
              </router-link>
            </swiper-slide>
            <swiper-slide>
              <router-link :to="{ name: 'home-r2-solution', query: { section: 4 } }" class="illu-s4">
                <strong>FaceGIDE</strong>
                <div class="txt" v-html="localize('정확하고, 안전한<br />디지털 양악, 재건 Solution')" />
              </router-link>
            </swiper-slide>
            <swiper-slide>
              <router-link :to="{ name: 'home-r2-solution', query: { section: 2 } }" class="illu-s3">
                <strong>Meg Aligner</strong>
                <div class="txt" v-html="localize('완벽한 심미의 마무리를 위한<br />성인 투명 교정 Solution')" />
              </router-link>
            </swiper-slide>
            <swiper-slide>
              <!-- <a @click="openInNewTab('/academy')" class="illu-l1"> -->
              <a @click.prevent="openYouTube" class="illu-l1">
                <strong>R2 Academy</strong>
                <div class="txt" v-html="localize('R2 사용의 모든 것!<br />R2 Academy에서 알려드려요')" />
              </a>
            </swiper-slide>
            <swiper-slide>
              <router-link to="/home/playground/planner" class="illu-l2">
                <strong>
                  R2 Planning
                  <br />
                  & Design Service
                </strong>
                <div class="txt" v-html="localize('공인된 R2 Specialist의 진단과<br />디자인 서비스를 경험 하세요')" />
              </router-link>
            </swiper-slide>
            <swiper-slide>
              <router-link to="/home/playground/r2center" class="illu-l3">
                <strong>R2 Center Service</strong>
                <div class="txt" v-html="localize('R2 digital Center에서 high quality의<br />보철물을 주문하실 수 있습니다.')" />
              </router-link>
            </swiper-slide>
            <div class="swiper-pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="container">
        <section class="sect">
          <div class="subtitle-wrap">
            <h2 class="font-poppins">
              Enjoy
              <br />
              R2 Solutions
            </h2>
            <p
              v-html="
                localize('Single Implant부터 Facial Reconstruction까지 <br/>다양한 임상 케이스를 위한 R2 솔루션을 지금 만나보세요.')
              "
            />
          </div>
          <swiper
            class="text-pagination-slider"
            :loop="true"
            :observer="true"
            :observe-parents="true"
            :modules="[Navigation, Pagination]"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            :pagination="{
              el: '.text-pagination-slider .swiper-pagination',
              type: 'bullets',
            }"
          >
            <swiper-slide>
              <div class="swiper-img">
                <img src="@/assets/home/img/playground/r2player1-1.png" alt="" />
              </div>
              <div class="btn-desc">
                <h3>R2 Digital Implant</h3>
                <p
                  v-html="
                    localize('CBCT 분석에서 임플란트 계획 수립, 가이드 디자인, <br/>원데이 보철까지 -<br/>치과 임플란트 수술을 위한 가장 직관적인 소프트웨어.<br/> R2GATE SA를 지금 만나보세요.')
                  "
                />
                <div class="btn-action-group">
                  <router-link :to="{ name: 'home-r2-solution', query: { section: 0 } }" class="btn btn-primary">
                    {{ localize("바로가기") }}
                    <i class="icon icon-arrow"></i>
                  </router-link>
                  <!-- <router-link :to="{ name: 'home-r2-solution', query: { section: 0 } }" class="btn btn-primary">
                    {{ localize("다운로드") }}
                    <i class="icon icon-arrow"></i>
                  </router-link> -->
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper-img">
                <img src="@/assets/home/img/playground/r2player1-2.png" alt="" />
              </div>
              <div class="btn-desc">
                <h3>
                  R2studio Q & QVD
                </h3>
                <p v-html="localize('Q-전악 치료의 새로운 기준 R2Studio Q는 전악 치료 계획 수립에 필요한 환자의 모든 데이터를 한번에 취합하여 Dental Avatar를 생성하고, Ai기반의 VD(Vertical Demension) 결정 프로그램인 QVD를 통해 무치악 치료 과정을 더욱 간편하고 효과적으로 만들어 드립니다.')" />
                <div class="d-flex">
                  <router-link :to="{ name: 'home-r2-solution', query: { section: 1 } }" class="btn btn-primary">
                    {{ localize("바로가기") }}
                    <i class="icon icon-arrow"></i>
                  </router-link>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper-img">
                <img src="@/assets/home/img/playground/r2player1-3.png" alt="" />
              </div>
              <div class="btn-desc">
                <h3>Meg Aligner</h3>
                <p
                  v-html="
                    localize('임플란트·보철 치료를 위한 투명 교정 솔루션<br/>진료 옵션이 넓어질수록, 환자의 만족도도 <br/>함께 높아집니다.')
                  "
                />
                <div class="btn-action-group">
                  <router-link :to="{ name: 'home-r2-solution', query: { section: 2 } }" class="btn btn-primary">
                    {{ localize("바로가기") }}
                    <i class="icon icon-arrow"></i>
                  </router-link>
                  <!-- <router-link :to="{ name: 'home-r2-solution', query: { section: 2 } }" class="btn btn-primary">
                    {{ localize("주문하기") }}
                  </router-link> -->
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper-img">
                <img src="@/assets/home/img/playground/r2player-1-fg.png" alt="" />
              </div>
              <div class="btn-desc">
                <h3>FaceGIDE</h3>
                <p
                  v-html="
                    localize('디지털 양악 수술 솔루션 <br/>환자 맞춤형 플레이트와 Saw Guide로 빠르고 정밀한<br/>수술을 지원하며,전용 앱을 통해 계획을 사전에<br/>확인해 더욱 안전한 수술이 가능합니다.')
                  "
                />
                <div class="btn-action-group">
                  <router-link :to="{ name: 'home-r2-solution', query: { section: 4 } }" class="btn btn-primary">
                    {{ localize("바로가기") }}
                    <i class="icon icon-arrow"></i>
                  </router-link>
                  <!-- <router-link :to="{ name: 'home-r2-solution', query: { section: 4 } }" class="btn btn-primary">
                    {{ localize("주문하기") }}
                  </router-link> -->
                </div>
              </div>
            </swiper-slide>
            <!-- <swiper-slide>
              <div class="swiper-img">
                <img src="@/assets/home/img/playground/r2player1-5.png" alt="" />
              </div>
              <div class="btn-desc">
                <h3>
                  R2studio Q
                  <br />
                  Smile Creator
                </h3>
                <p
                  v-html="
                    localize('R2Q면, 즉시 상담이 가능한 Ai Smile Creator<br /> 환자를 스캔하면 상담은 5분안에 가능<br /> 환자의 치과에 대한 신뢰는 평생!')
                  "
                />
                <router-link :to="{ name: 'home-r2-solution', query: { section: 7 } }" class="btn btn-primary">
                  바로가기
                  <i class="icon icon-arrow"></i>
                </router-link>
              </div>
            </swiper-slide> -->
            <div class="swiper-pagination pagination_bullet"></div>
            <div class="swiper-controls type-line">
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
          </swiper>
        </section>
        <section class="sect">
          <div class="subtitle-wrap">
            <h2 class="font-poppins">
              Play Together
            </h2>
            <span
              v-html="
                localize('빠르고 편리한 맞춤형 서비스를 지금 경험해 보세요.<br/>전 세계 인증된 R2 Planner와 R2 Center가<br/>당신의 주문을 기다리고 있습니다.')
              "
            />
            <img src="@/assets/home/img/playground/r2player2-tit.png" alt="" class="subtit-illu" />
          </div>
          <div class="timeline">
            <ul>
              <li>
                <img src="@/assets/home/img/playground/r2player-pingpong.png" alt="" />
                <div class="btn-desc">
                  <h3>R2iOS & Ping Pong</h3>
                  <p v-html="localize('Pingpong 하나면, 데이터 전송부터 주문,<br />온라인 채팅까지 한 번에!<br/>설치만 하면 진료실에서 바로 실시간 소통과<br/>간편한 주문이 가능합니다.')" />
                  <!-- <a v-bind:href="downloadLink" target="_blank" class="btn btn-primary">
                    APP Download
                    <i class="icon icon-arrow"></i>
                  </a> -->
                </div>
              </li>
              <li>
                <img src="@/assets/home/img/playground/r2player2-2.png" alt="" />
                <div class="btn-desc">
                  <h3>R2 Planner</h3>
                  <p v-html="localize('R2GATE x CAD 디자인의 숙련된 파트너, R2 Planner<br/>빠르고 신뢰할 수 있는 디자인 서비스를<br/>지금 경험해보세요.')" />
                  <!--<router-link to="planner" class="btn btn-primary">
                    R2 Planner
                    <i class="icon icon-arrow"></i>
                  </router-link>-->
                  <a @click="alert(localize('준비 중 입니다.'))" class="btn btn-primary">
                    {{ localize("더 알아보기") }}
                    <i class="icon icon-arrow"></i>
                  </a>
                </div>
              </li>
              <li>
                <img src="@/assets/home/img/playground/r2player2-3.png" alt="" />
                <div class="btn-desc">
                  <h3>R2 Center</h3>
                  <p v-html="localize('지금,R2 Center의 디지털 보철 서비스를<br/>경험해보세요.<br/>서지컬 가이드부터 풀 마우스 보철까지,<br/>전문가의 퀄리티를 직접 확인하세요.')" />
                  <!--<router-link to="/home/playground/r2center" class="btn btn-primary">
                    R2 Center
                    <i class="icon icon-arrow"></i>
                  </router-link>-->
                  <a @click="alert(localize('준비 중 입니다.'))" class="btn btn-primary">
                    {{ localize("더 알아보기") }}
                    <i class="icon icon-arrow"></i>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <section class="sect text-center">
          <!-- 다국어 누락 -->
          <h3 class="fs-3 mb-2">
            {{ localize("R2 Playground를 더 재미있게~") }}
          </h3>
          <!-- 다국어 누락 -->
          <p class="fs-4 mb-4 mt-4"
            v-html="localize('R2 Academy와 R2 Playground TV에서<br/>R2 솔루션에 대한 다양한 콘텐츠와 영상을 만나보세요.')"
          />
          <a @click.prevent="openYouTube" class="btn btn-outline">
            {{  localize("바로 보기") }}
            <i class="icon icon-arrow-black"></i>
          </a>
          <div class="bubble-wrap">
            <div class="bubble-right">
              <div class="bubble">
                <span v-html="localize('R2 academy는 R2에 대한<br />모든 정보를 공유해드립니다.')" />
                <img src="@/assets/home/img/icon-smile.png" alt="" class="icon" />
              </div>
              <div class="bubble">
                {{ localize("R2의 모든 사용법을 알 수 있어요!") }}
              </div>
              <div class="bubble" v-html="localize('R2 동영상 콘텐츠로 쉽게! 빠르게!<br />재미있게! 학습해요')" />
            </div>
            <div>
              <img src="@/assets/home/img/playground/r2player3.jpg" alt="" />
            </div>
            <div class="bubble-left">
              <div class="bubble">
                <span v-html="localize('R2 사용중 모르는게 있다면<br />R2 academy를 이용해보세요')" />
                <img src="@/assets/home/img/icon-thumb.png" alt="" class="icon" />
              </div>
              <div class="bubble">
                {{ localize("R2 Player의 배움터로 오세요") }}
              </div>
              <div class="bubble">{{ localize("R2 Academy에서 만나요") }}</div>
            </div>
          </div>
        </section>
      </div>
      <!-- //container -->
    </main>
    <!-- footer -->
    <home-footer />
    <!-- //footer -->

    <div class="bg-blur"></div>
  </div>
</template>

<style scoped>
.btn-action-group {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
